// extracted by mini-css-extract-plugin
export default {"note-delete__title":"NoteDelete_note-delete__title__ZMgh1","note-delete__btn-box":"NoteDelete_note-delete__btn-box__hFAJo"};